import React, { FC } from "react";
import { Id } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { activeSubscriptionIdState, people_rolesState } from "../../../atoms";
import { Button, useToast } from "@chakra-ui/react";
import { unlinkPersonFromRole } from "../../../api/unlink-person-from-role";

type Props = {
  personId: Id;
  roleId: Id;
  onSuccess: () => void;
};

export const UnlinkPersonFromRole: FC<Props> = (props) => {
  const { personId, roleId, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setPeople_roles = useSetRecoilState(people_rolesState);

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        unlinkPersonFromRole({
          personId,
          roleId,
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setPeople_roles(event.data.people_roles);
        onSuccess();
        toast({
          title: "koppeling tussen persoon en rol verwijderd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "verwijderen van koppeling niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <Button
      type="submit"
      size="sm"
      isLoading={state.matches("loading")}
      onClick={() => {
        send(state.matches("failure") ? "RETRY" : "FETCH");
      }}
    >
      bevestig
    </Button>
  );
};
